<template>
  <div class="container">
    <RoomProvider></RoomProvider>
    <BookingProvider :date="date"></BookingProvider>

    <div class="sticky">
      <DateSelectGadget class="date-select" :class="$mq" :date="date" @update="handleDateChange($event)"></DateSelectGadget>
    </div>
    <mq-layout class="mobile-wrapper" mq="mobile">
      <RoomSelectButton v-for="room in rooms" :key="room.id" :room="room" :date="date"></RoomSelectButton>
      <div v-if="false && loading">Loading...</div>
    </mq-layout>
    <mq-layout class="wide-wrapper" mq="tablet+">
      <RoomSelectWideGrid :cols="$mq | mq({tablet: 2, laptop: 3, desktop: 4, large: 5, xl: 6})" :date="date" :rooms="rooms"></RoomSelectWideGrid>
    </mq-layout>
  </div>
</template>

<script>
import RoomProvider from '@/components/providers/RoomProvider';
import BookingProvider from '@/components/providers/BookingProvider';

import DateSelectGadget from '@/components/DateSelectGadget'
import RoomSelectButton from '@/components/RoomSelectButton'
import RoomSelectWideGrid from '@/components/RoomSelectWideGrid'

import TimeUtils from './../utils/TimeUtils'
import types from './../store/types'

import Booking from './../store/modules/booking/types'
import Room from './../store/modules/room/types'

import { mapGetters, mapActions } from 'vuex'

export default {
  components: {RoomProvider, BookingProvider, RoomSelectButton, RoomSelectWideGrid, DateSelectGadget },
  name: 'RoomSelectView',
  data () {
    return {
      status: {
        roomsLoaded: false,
        weekLoaded: false,
      }
    }
  },
  methods: {
    selectRoom (id) {
      this.setSelectedRoom(id);
    },
    handleDateChange (newDate) {
      this.selectDate(newDate);
      console.log('handleDateChange', newDate);
    },
    ...mapActions(['setSelectedRoom', 'selectDate']),
  },
  computed: {
    date () {
      return this.getSelectedDate();
    },
    loading () {
      return !(this.status.roomsLoaded && this.status.weekLoaded);
    },
    rooms () {
      return this.getRooms()
    },
    selectedRoomId () {
      const id = this.$store.state.selectedRoomId;
      return id;
    },
    ...mapGetters([types.getters.GET_SELECTED_DATE]),
    ...mapGetters('Booking', [Booking.getters.GET_BOOKINGS_BY_ROOM]),
    ...mapGetters('Room', [Room.getters.GET_ROOMS]),
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>

@import 'src/color.scss';

.mobile-wrapper {
  max-width: 400px;
  margin: 0 auto;
}

.wide-wrapper {
  width: 100%;
  max-width: 1700px;
  margin: 0 auto;
}

.date-select {
  width: auto;

  &:not(.mobile) {
    padding-left: 0.5em;
    padding-right: 0.5em;
  }

  &.mobile {
    width: 100%;
  }
  // &.desktop {
  //   width: 90%;
  // }
}

h1, h2 {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/RoomSelectView.vue